// ---------------------------------------------------------------------------
// PLE-32: closing the destination left every route line (fastest/scenic/
// pleasant) stuck on the map — the grey "fastest" line in the bug report was
// just the one that happened to show in the screenshot; all of them stayed.
//
// `scored` is only cleared on a NEW search submit (handleSearchSubmit in
// Index.tsx). Closing the destination via the search field's ✕
// (handleSearchChange) just nulls `destination` and leaves `scored` as-is,
// because that ✕ doesn't start a new trip — there's nothing to clear it on.
// The route-card panel already hides itself once `destination` is null
// (`{destination && (...)}` in Index.tsx); MapView's `routes` prop didn't
// check the same thing, so the stale polylines kept drawing with no card
// left to match them.
//
// One place to decide "is there a trip to draw a line for", fed straight
// into MapView's `routes` prop, so a future caller reading `scored` /
// `displayedScoredWithDetours` directly can't reintroduce the bug.
// ---------------------------------------------------------------------------

/**
 * Routes belong on the map only while there's an actual destination to draw
 * them for. `cardsHeld` is the pre-existing "routes computed but not yet
 * shown" gate — kept as a separate check, not replaced by the destination
 * one.
 */
export function visibleMapRoutes<T>(
  destination: unknown,
  cardsHeld: boolean,
  scoredRoutes: T[],
): T[] {
  return destination && !cardsHeld ? scoredRoutes : [];
}
